export const CLONE_PARAM = 'clone' as const;

export type CloneParam = `${typeof CLONE_PARAM}-${number}`;

export const createCloneParam = (id: number): CloneParam =>
  `${CLONE_PARAM}-${id}` as const;

export const isCloneParam = (param: any): param is CloneParam =>
  typeof param === 'string' && param.startsWith(CLONE_PARAM);

export const parseCloneParam = (param: CloneParam): number =>
  parseInt(param.split('-')[1], 10);
